import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { PrivacyPolicySEO } from './SEO';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen">
      <PrivacyPolicySEO />
      <Header />
      <main className="py-16 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <article className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
            <h1 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-8">
              Politica de Privacidad
            </h1>

            <p className="text-slate-600 mb-8">
              Ultima actualizacion: 30 de diciembre de 2025
            </p>

            <div className="prose prose-slate max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  1. Informacion que Recopilamos
                </h2>
                <p className="text-slate-600 mb-4">
                  En Neurolytics, respetamos tu privacidad y nos comprometemos a proteger tu informacion personal.
                  Recopilamos la siguiente informacion cuando utilizas nuestros servicios:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Nombre y apellido</li>
                  <li>Correo electronico</li>
                  <li>Numero de telefono</li>
                  <li>Nombre de empresa (opcional)</li>
                  <li>Informacion sobre tu proyecto o consulta</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  2. Como Utilizamos tu Informacion
                </h2>
                <p className="text-slate-600 mb-4">
                  Utilizamos la informacion recopilada para:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Responder a tus consultas y solicitudes</li>
                  <li>Proporcionarte informacion sobre nuestros servicios</li>
                  <li>Mejorar nuestros servicios y experiencia de usuario</li>
                  <li>Enviarte comunicaciones relevantes (con tu consentimiento)</li>
                  <li>Cumplir con obligaciones legales</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  3. Proteccion de Datos
                </h2>
                <p className="text-slate-600 mb-4">
                  Implementamos medidas de seguridad tecnicas y organizativas para proteger tu informacion personal
                  contra acceso no autorizado, alteracion, divulgacion o destruccion. Esto incluye:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Cifrado de datos en transito y en reposo</li>
                  <li>Acceso restringido a informacion personal</li>
                  <li>Monitoreo continuo de nuestros sistemas</li>
                  <li>Capacitacion regular de nuestro equipo en seguridad</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  4. Comparticion de Datos
                </h2>
                <p className="text-slate-600 mb-4">
                  No vendemos, alquilamos ni compartimos tu informacion personal con terceros, excepto:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Cuando sea necesario para proporcionar nuestros servicios</li>
                  <li>Con proveedores de servicios que trabajan en nuestro nombre</li>
                  <li>Cuando la ley lo requiera</li>
                  <li>Con tu consentimiento explicito</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  5. Tus Derechos
                </h2>
                <p className="text-slate-600 mb-4">
                  Tienes derecho a:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Acceder a tu informacion personal</li>
                  <li>Rectificar datos inexactos</li>
                  <li>Solicitar la eliminacion de tus datos</li>
                  <li>Oponerte al procesamiento de tus datos</li>
                  <li>Solicitar la portabilidad de tus datos</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  6. Cookies
                </h2>
                <p className="text-slate-600 mb-4">
                  Utilizamos cookies y tecnologias similares para mejorar tu experiencia en nuestro sitio web.
                  Puedes gestionar tus preferencias de cookies a traves de la configuracion de tu navegador.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  7. Contacto
                </h2>
                <p className="text-slate-600 mb-4">
                  Si tienes preguntas sobre esta politica de privacidad o sobre como manejamos tu informacion,
                  puedes contactarnos en:
                </p>
                <ul className="list-none text-slate-600 space-y-2">
                  <li><strong>Email:</strong> hola@neurolytics.cl</li>
                  <li><strong>WhatsApp:</strong> +56 9 6294 2789</li>
                  <li><strong>Ubicacion:</strong> Los Lagos, Chile</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  8. Actualizaciones de esta Politica
                </h2>
                <p className="text-slate-600">
                  Nos reservamos el derecho de actualizar esta politica de privacidad en cualquier momento.
                  Las actualizaciones seran publicadas en esta pagina con la fecha de la ultima modificacion.
                </p>
              </section>
            </div>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <a
                href="/"
                className="text-emerald-600 hover:text-emerald-700 font-medium transition-colors duration-200"
              >
                ← Volver al inicio
              </a>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
